module.exports = __webpack_public_path__ + "static/loading-1bfc15e6fb2ca2d9340de22693959787.gif";